import Instance from "../../../../Axios";

// New Actions for the app

const GetCredEstados = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/estados`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_ESTADOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredEstados;
